import { TIPOS_CANDIDATO } from "../constants/tiposCandidato";

// votos que no son de un candidato: salen de las actas E-14 (escrutinios)
const CAMPOS_ESPECIALES = [
  { campo: "votosBlanco", nombre: "Votos en blanco" },
  { campo: "votosNulos", nombre: "Votos nulos" },
  { campo: "votosNoMarcados", nombre: "Votos no marcados" },
];

const porcentaje = (parte, total) => (total > 0 ? (parte / total) * 100 : 0);

// Resumen por corporación (alcalde / concejo) para el dashboard:
// - candidatos ordenados de mayor a menor votación, con su % de votos válidos
//   (candidatos + en blanco, como lo calcula la Registraduría)
// - quién va ganando y la ventaja sobre el segundo
// - votos especiales y avance de mesas, sumados de las actas
export const calcularTotalesConteo = (conteo, candidatos, escrutinios = []) => {
  const votosPorCandidato = conteo.reduce((acc, registro) => {
    acc[registro.candidatoId] = (acc[registro.candidatoId] ?? 0) + Number(registro.votos);
    return acc;
  }, {});

  return TIPOS_CANDIDATO.map(({ value, label }) => {
    const actas = escrutinios.filter((escrutinio) => escrutinio.corporacion === value);
    const especiales = CAMPOS_ESPECIALES.map(({ campo, nombre }) => ({
      id: campo,
      nombre,
      valor: actas.reduce((suma, acta) => suma + Number(acta[campo]), 0),
    }));

    const votosCandidatos = candidatos
      .filter((candidato) => candidato.tipo === value)
      .map((candidato) => ({
        id: candidato.id,
        nombre: candidato.nombre,
        valor: votosPorCandidato[candidato.id] ?? 0,
      }));

    const sumaCandidatos = votosCandidatos.reduce((suma, c) => suma + c.valor, 0);
    const votosValidos = sumaCandidatos + especiales[0].valor;

    const ranking = votosCandidatos
      .map((c) => ({ ...c, porcentaje: porcentaje(c.valor, votosValidos) }))
      .sort((a, b) => b.valor - a.valor || a.nombre.localeCompare(b.nombre));

    // solo hay ganador si ya se registraron votos
    const lider = ranking[0]?.valor > 0 ? ranking[0] : null;
    const segundo = lider ? ranking[1] ?? null : null;

    return {
      corporacion: value,
      nombre: label,
      ranking,
      maxVotos: lider?.valor ?? 0,
      lider,
      segundo,
      empate: Boolean(lider && segundo && lider.valor === segundo.valor),
      diferencia: lider ? lider.valor - (segundo?.valor ?? 0) : 0,
      diferenciaPuntos: lider ? lider.porcentaje - (segundo?.porcentaje ?? 0) : 0,
      especiales,
      votosValidos,
      totalGeneral: sumaCandidatos + especiales.reduce((suma, e) => suma + e.valor, 0),
      mesasEscrutadas: actas.length,
      mesasCerradas: actas.filter((acta) => acta.estado === "cerrado").length,
    };
  });
};
